import type { InspectionTemplate, InspectionTemplateBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<InspectionTemplate, InspectionTemplateBase>({
  tableName: "inspection_templates",
  searchColumns: ["name"],
});

export class InspectionTemplateService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
